"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAttributesToObject = void 0;
function userAttributesToObject(userAttributes) {
    return userAttributes.reduce((obj, attr) => {
        return {
            obj,
            [attr.Name]: attr.Value,
        };
    }, {});
}
exports.userAttributesToObject = userAttributesToObject;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29nbml0b0hlbHBlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvY29nbml0b0hlbHBlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsU0FBZ0Isc0JBQXNCLENBQ3BDLGNBQTJDO0lBRTNDLE9BQU8sY0FBYyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEdBQUcsRUFBRSxJQUFJLEVBQUUsRUFBRTtRQUN6QyxPQUFPO1lBQ0wsR0FBRztZQUNILENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLElBQUksQ0FBQyxLQUFLO1NBQ3hCLENBQUM7SUFDSixDQUFDLEVBQUUsRUFBRSxDQUFNLENBQUM7QUFDZCxDQUFDO0FBVEQsd0RBU0MifQ==